// extracted by mini-css-extract-plugin
module.exports = {"root":"_root__lFkcr","more":"_more__Ikc4e","expanded":"_expanded__Ntphb"};